export default {
    'task.qjkbc': '请尽快补充',
    'task.bctip': '补充完成后点击处理完成',
    'task.clwc': '处理完成',
    'task.nodata': '没有数据'
}